import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import {Input} from "@material-ui/core";
import {parseIntegerInputOrEmpty} from "../../../../../../utils/forms/parseNumberInput";

export default function EntryTacticUserPrefs({entryHooks}) {
    let {
        marketOrderEnabled,
        setMarketOrderEnabled,
        limitOrderEnabled,
        setLimitOrderEnabled,
        limitOrderOffsetAmount,
        setLimitOrderOffsetAmount,
        setLimitFromSetupBreakPrice,
        setSetLimitFromSetupBreakPrice,
        candleBreakEnabled,
        setCandleBreakEnabled,
        candleBreakCandleDuration,
        setCandleBreakCandleDuration,
        breakBy,
        setBreakBy,
        waitUntilCurrentCandleCloses,
        setWaitUntilCurrentCandleCloses,
        dollarStock,
        setDollarStock,
        dollarOption,
        setDollarOption,
        qtyStock,
        setQtyStock,
        qtyOption,
        setQtyOption,
    } = entryHooks;

    let [offSetTxt, setOffsetTxt] = useState("");
    let [candleDurationTxt, setCandleDurationTxt] = useState("");
    let [breakByTxt, setBreakByTxt] = useState("");

    let [dollarStockTxt, setDollarStockTxt] = useState("");
    let [dollarOptionTxt, setDollarOptionTxt] = useState("");
    let [qtyStockTxt, setQtyStockTxt] = useState("");
    let [qtyOptionTxt, setQtyOptionTxt] = useState("");

    const UseEffectFactory = (dependency, setter) => {
        return useEffect(() => {
            setter(dependency + "");
        }, [dependency]);
    };
    UseEffectFactory(dollarStock, setDollarStockTxt);
    UseEffectFactory(dollarOption, setDollarOptionTxt);
    UseEffectFactory(qtyStock, setQtyStockTxt);
    UseEffectFactory(qtyOption, setQtyOptionTxt);

    UseEffectFactory(limitOrderOffsetAmount, setOffsetTxt);
    UseEffectFactory(candleBreakCandleDuration, setCandleDurationTxt);
    UseEffectFactory(breakBy, setBreakByTxt);

    return (
        <>
            <Grid container>
                <Grid item>
                    <Typography>
                        <b>Entry tactics:</b>
                    </Typography>
                </Grid>
                <Grid item container spacing={2}>
                    <Grid item xs={5}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"dollarStock"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"dlrStock"}
                            size="small"
                            style={{height: 15}}
                            value={dollarStockTxt}
                            onChange={(ev) => {
                                setDollarStockTxt(ev.target.value);
                            }}
                            onBlur={(ev) => setDollarStock(parseFloat(ev.target.value))}
                            endAdornment={"$"}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"dollarOption"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"dlrOption"}
                            size="small"
                            style={{height: 15}}
                            value={dollarOptionTxt}
                            onChange={(ev) => {
                                setDollarOptionTxt(ev.target.value);
                            }}
                            onBlur={(ev) => setDollarOption(parseFloat(ev.target.value))}
                            endAdornment={"$"}
                        />
                    </Grid>
                </Grid>
                <Grid item container spacing={2}>
                    <Grid item xs={5}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"qtyStock"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"qtyStock"}
                            size="small"
                            style={{height: 15}}
                            value={qtyStockTxt}
                            onChange={(ev) => {
                                setQtyStockTxt(ev.target.value);
                            }}
                            onBlur={(ev) => setQtyStock(parseInt(ev.target.value))}
                            endAdornment={"shares"}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"qtyOption"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"qtyOption"}
                            size="small"
                            style={{height: 15}}
                            value={qtyOptionTxt}
                            onChange={(ev) => {
                                setQtyOptionTxt(ev.target.value);
                            }}
                            onBlur={(ev) => setQtyOption(parseInt(ev.target.value))}
                            endAdornment={"contracts"}
                        />
                    </Grid>
                </Grid>
                <Grid item container>
                    <Grid item xs={3}>
                        <Typography>
                            <u>MarketOrder</u>
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <FormControlLabel
                            value={marketOrderEnabled}
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={marketOrderEnabled}
                                    onChange={(ev) => {
                                        setMarketOrderEnabled(ev.target.checked);
                                    }}
                                />
                            }
                            label={
                                <Typography style={{fontSize: 12}}>default on</Typography>
                            }
                            labelPlacement="start"
                        />
                    </Grid>
                </Grid>
                <Grid item>
                    <br/>
                    <br/>
                </Grid>
                <Grid item container spacing={1}>
                    <Grid item xs={3}>
                        <Typography>
                            <u>LimitOrder</u>
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <FormControlLabel
                            value={limitOrderEnabled}
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={limitOrderEnabled}
                                    onChange={(ev) => {
                                        setLimitOrderEnabled(ev.target.checked);
                                    }}
                                />
                            }
                            label={
                                <Typography style={{fontSize: 12}}>default on</Typography>
                            }
                            labelPlacement="start"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"offset"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"offsetTxt"}
                            size="small"
                            style={{height: 15}}
                            value={(offSetTxt)}
                            onChange={(ev) => {
                                setOffsetTxt(ev.target.value);
                            }}
                            endAdornment={"$"}
                            onBlur={(ev) =>
                                setLimitOrderOffsetAmount(parseFloat(ev.target.value))
                            }
                        />
                    </Grid>
                </Grid>
                <Grid item container spacing={1}>
                    <Grid item xs={1}>
                        <Typography>
                            <u>CandleBreak</u>
                        </Typography>
                    </Grid>
                    <Grid item xs={1}/>
                    <Grid item xs={3}>
                        <FormControlLabel
                            value={candleBreakEnabled}
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={candleBreakEnabled}
                                    onChange={(ev) => {
                                        setCandleBreakEnabled(ev.target.checked);
                                    }}
                                />
                            }
                            label={
                                <Typography style={{fontSize: 12}}>default on</Typography>
                            }
                            labelPlacement="start"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"candleDuration"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"candleDuration"}
                            size="small"
                            style={{height: 15}}
                            value={candleDurationTxt}
                            onChange={(ev) => {
                                setCandleDurationTxt(ev.target.value);
                            }}
                            onBlur={(ev) =>
                                setCandleBreakCandleDuration(parseIntegerInputOrEmpty(ev.target.value))
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormControlLabel
                            value={waitUntilCurrentCandleCloses}
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={waitUntilCurrentCandleCloses}
                                    onChange={(ev) => {
                                        setWaitUntilCurrentCandleCloses(ev.target.checked);
                                    }}
                                />
                            }
                            label={
                                <Typography style={{fontSize: 8}}>
                                    wait until current candle closes
                                </Typography>
                            }
                            labelPlacement="start"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel style={{fontSize: "1rem"}}>
                            <Typography style={{fontSize: 7}}>
                                <b>{"breakBy"}:</b>
                            </Typography>
                        </InputLabel>
                        <Input
                            id={"breakBy"}
                            size="small"
                            style={{height: 15}}
                            value={breakByTxt}
                            onChange={(ev) => {
                                setBreakByTxt(ev.target.value);
                            }}
                            onBlur={(ev) => setBreakBy(parseFloat(ev.target.value))}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
